import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Admin from 'components/admin/admin';

class AdminController extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loadErrMsg: null,
			prevPage: null,
		};
		this.timeout = null;
	}

	/**
	 * Go to page ()
	 * @param {string} page 
	 */
	goToPage = (page) => {
		const prevPage = this.state.page;
		this.setState({page, prevPage});
	};


	/**
	 * Render component
	 */
	render() {
		return (
			<Admin 
				email={this.props.email}
				languageId={'da'}
				goToPage={this.goToPage}
				handleLogout={this.props.handleLogout}
			/>
		);
	}
}

AdminController.propTypes = {
	email: PropTypes.string.isRequired,
	handleLogout: PropTypes.func.isRequired,
};

export default AdminController;